module.exports = __webpack_public_path__ + "img/KITANCESS+KITANCSMIS EN.8b332b13.png";